import React, { useState, useEffect, useMemo, useRef } from "react";
import { useFilterContext } from "../../helpers/FilterContext";

const RenderCategories = ({ categories }) => {
  const [visibleLevels, setVisibleLevels] = useState({});
  const { state, dispatch } = useFilterContext();
  const [selectedCategories, setSelectedCategories] = useState([]);
  const prevCategoriesIdsRef = useRef(null);

  // Convertir categories_ids a array si es necesario y normalizar
  // Usar JSON.stringify en la dependencia para comparar valores, no referencias
  const categoriesIdsKey = JSON.stringify(state.urlTestParams.filters?.categories_ids);

  const categoriesIdsArray = useMemo(() => {
    const categoriesIds = state.urlTestParams.filters?.categories_ids;

    if (!categoriesIds) return [];

    if (Array.isArray(categoriesIds)) {
      return categoriesIds
        .map((id) => Number(id))
        .filter((id) => !isNaN(id))
        .sort((a, b) => a - b);
    }

    // Si es un objeto, extraer los IDs
    if (typeof categoriesIds === "object") {
      return Object.values(categoriesIds)
        .map((cat) => {
          if (typeof cat === "object" && cat !== null) {
            return Number(cat.value || cat.id);
          }
          return Number(cat);
        })
        .filter((id) => !isNaN(id))
        .sort((a, b) => a - b);
    }

    return [];
  }, [categoriesIdsKey]);

  useEffect(() => {
    // Comparar valores usando JSON.stringify para evitar bucles infinitos
    // categoriesIdsArray ya está ordenado en el useMemo
    const currentIdsString = JSON.stringify(categoriesIdsArray);
    const prevIdsString = prevCategoriesIdsRef.current;

    // Solo actualizar si realmente cambió el contenido
    if (currentIdsString !== prevIdsString) {
      prevCategoriesIdsRef.current = currentIdsString;
      setSelectedCategories([...categoriesIdsArray]);
    }
  }, [categoriesIdsArray]);

  const toggleLevel = (path) => {
    setVisibleLevels((prev) => ({ ...prev, [path]: !prev[path] }));
  };

  const handleCheckBoxClick = (category) => {
    let updatedCategories = [...selectedCategories];
    const categoryId = category.id;
    const isCurrentlySelected = updatedCategories.includes(categoryId);

    if (isCurrentlySelected) {
      // Solo eliminar la categoría seleccionada, sin afectar subcategorías
      updatedCategories = updatedCategories.filter((id) => id !== categoryId);
    } else {
      // Solo agregar la categoría seleccionada, sin incluir subcategorías
      updatedCategories.push(categoryId);
    }

    setSelectedCategories(updatedCategories);
    dispatch({ type: "UPDATE_FILTERS", payload: { filterId: "categories_ids", values: updatedCategories } });
  };

  const renderCategories = (categories, level = 0, path = "") => {
    if (!categories) return null;

    return categories.map((category, index) => {
      const newPath = `${path}/${index}`;
      const hasSubcategories = category.categories?.length > 0;
      const isChecked = selectedCategories.includes(category.id);

      return (
        <div key={category.id}>
          <div style={{ marginLeft: `${level * 20}px`, cursor: "pointer", display: "flex", alignItems: "center" }}>
            <div className="w-full" onClick={() => handleCheckBoxClick(category)}>
              <span
                className={`w-[15px] h-[15px] border border-primary inline-block mr-2 rounded-full checkbox-filter ${
                  isChecked ? "checked" : ""
                }`}
              ></span>
              <label>{category.description}</label>
            </div>
            {hasSubcategories && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                width="24"
                height="24"
                style={{ marginRight: "5px" }}
                onClick={() => toggleLevel(newPath)}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            )}
          </div>
          {visibleLevels[newPath] && hasSubcategories && (
            <div>{renderCategories(category.categories, level + 1, newPath)}</div>
          )}
        </div>
      );
    });
  };

  return <div>{renderCategories(categories)}</div>;
};

export default RenderCategories;
